const pages = {
  'menu_item_main':'Главная',
  'menu_item_sms':'SMS',
  'menu_item_sms_clients_routing':'Маршрутизация и тарификация SMS-клиентов',
  'menu_item_sms_provider_routing':'Маршрутизация и тарификация SMS-поставщиков услуг',
  'menu_item_sms_pool_rules':'Изменение адреса отправителя',
  'menu_item_sms_filter':'Блокировка по тексту SMS',
  'menu_item_sms_filter_all_partners':'Общие правила блокировки SMS по тексту',
  'menu_item_sms_set_priority':'Изменение приоритета',
  'menu_item_sms_duplicate':'Блокировка одинаковых сообщений',
  'menu_item_sms_templates':'Шаблоны',
  'menu_item_sms_originators':'Ограничение адресов отправителей',
  'menu_item_settings_duplicate':'Блокировка одинаковых сообщений',
  'menu_item_call':'Звонки',
  'menu_item_call_sounds':'Библиотека звуков',
  'menu_item_call_ivr':'IVR меню',
  'menu_item_call_templates':'Шаблоны',
  'menu_item_call_clients_routing':'Маршрутизация и тарификация Call клиентов',
  'menu_item_call_provider_routing':'Маршрутизация и тарификация Call поставщиков услуг',
  'menu_item_call_pool_rules':'Изменение адреса отправителя',
  'menu_item_call_services':'Сервисы',
  'menu_item_email':'Электронная почта',
  'menu_item_email_route':'Маршрутизация и тарификация Email',
  'menu_item_email_clients_tariff':'Тарификация Email клиентов',
  'menu_item_email_provider_tariff':'Тарификация Email поставщиков услуг',
  'menu_item_email_templates':'Шаблоны',
  'menu_item_email_tariff':'Тарификация',
  'menu_item_statistics_email_events_group': 'Групповая статистика событий Email',
  'menu_item_user_manage':'Управление</br>пользователями',
  'menu_item_user_manage_user_partners':'Пользователи личного кабинета',
  'menu_item_user_manage_user_system':'Пользователи системы',
  'menu_item_user_manage_user_role':'Роли',
  'menu_item_user_manage_user_partners_role': 'Роли пользователей личного кабинета',
  'menu_item_user_manage_user_logs':'Действия пользователей',
  'menu_item_user_manage_system_actions':'Настройки логирования действий пользователей',
  'menu_item_user_manage_user_cc':'Пользователи колл-центра',
  'menu_item_settings_black_list':'Черные списки',
  'menu_item_settings_general_black_list':'Общие черные списки',
  'menu_item_user_manage_template_moderation':'Модерация шаблонов',
  'menu_item_settings':'Настройки',
  'menu_item_settings_accounts':'Аккаунты',
  'menu_item_settings_providers':'Поставщики услуг',
  'menu_item_settings_clients':'Клиенты',
  'menu_item_settings_senders':'Адреса отправителей',
  'menu_item_settings_cms':'Настройки системы',
  'menu_item_user_manage_distr':'Модерация рассылок',
  'menu_item_settings_operator_smpp':'Подключения к операторам по SMPP',
  'menu_item_settings_pool':'Пулы номеров',
  'menu_item_settings_message_types':'Типы сообщений',
  'menu_item_settings_additional_rules':'Дополнительные правила',
  'menu_item_settings_templates_params':'Дополнительные параметры шаблона',
  'menu_item_settings_set_priority':'Изменение приоритета',
  'menu_item_statistics':'Статистика',
  'menu_item_statistics_export_reports':'Отчеты по экспорту',
  'menu_item_lcr_check':'Проверка LCR роутинга',
  'menu_item_settings_logica_smpp':'Подключения поставщиков услуг',
  'menu_item_settings_server_smpp':'Подключения клиентов',
  'menu_item_statistics_sms_detail':'Детальная статистика SMS',
  'menu_item_statistics_sms_group':'Групповая статистика SMS',
  'menu_item_statistics_sms_mo_detail':'Детальная статистика входящих SMS',
  'menu_item_statistics_sms_mo_group':'Групповая статистика входящих SMS',
  'menu_item_statistics_email_detail':'Детальная статистика Email',
  'menu_item_statistics_email_group':'Групповая статистика Email',
  'menu_item_statistics_call_detail':'Детальная статистика звонков',
  'menu_item_statistics_call_mo_detail':'Детальная статистика входящих звонков',
  'menu_item_statistics_call_group':'Групповая статистика звонков',
  'menu_item_statistics_call_mo_group':'Групповая статистика входящих звонков',
  'menu_item_statistics_push_detail':'Детальная статистика Push',
  'menu_item_statistics_push_group':'Групповая статистика Push',
  'menu_item_statistics_ussd_group':'Групповая статистика USSD',
  'menu_item_statistics_ussd_detail':'Детальная статистика USSD',
  'menu_item_statistics_viber_group':'Групповая статистика Viber',
  'menu_item_statistics_viber_detail':'Детальная статистика Viber',
  'menu_item_viber_mo_routing':'Маршрутизация входящих сообщений',
  'menu_item_statistics_viber_mo_detail':'Детальная статистика входящих Viber',
  'menu_item_statistics_viber_mo_group':'Групповая статистика входящих Viber',
  'menu_item_statistics_export':'Отчеты по экспорту',
  'menu_item_login':'Аутентификация',
  'menu_item_push':'Push',
  'menu_item_push_clients_tariff':'Тарификация Push-клиентов',
  'menu_item_push_applications':'Управление приложениями',
  'menu_item_push_groups_applications':'Группы приложений',
  'menu_item_push_app_attribute':'Атрибуты приложений',
  "menu_item_push_subscribers": "Количество подписчиков",
  "menu_item_push_history": "История подписок",
  'menu_item_push_tariff':'Тарификация',
  'menu_item_push_templates':'Шаблоны',
  'menu_item_ussd':'USSD',
  'menu_item_ussd_menu':'USSD меню',
  'menu_item_ussd_clients_routing':'Маршрутизация и тарификация USSD клиентов',
  'menu_item_ussd_provider_routing':'Маршрутизация и тарификация USSD поставщиков услуг',
  'menu_item_ussd_routing':'Маршрутизация входящих USSD-запросов',
  'menu_item_ussd_templates':'Шаблоны',
  'menu_item_viber':'Viber',
  'menu_item_viber_clients_tariff':'Тарификация Viber клиентов',
  'menu_item_viber_provider_tariff':'Тарификация Viber поставщиков услуг',
  'menu_item_viber_templates':'Шаблоны',
  'menu_item_whatsapp':'WhatsApp',
  'menu_item_whatsapp_templates':'Шаблоны',
  'menu_item_statistics_whatsapp_detail':'Детальная статистика',
  'menu_item_statistics_whatsapp_group':'Групповая статистика',
  'menu_item_whatsapp_clients_tariff':'Тарификация WhatsApp клиентов',
  'menu_item_whatsapp_provider_tariff':'Тарификация WhatsApp поставщиков услуг',
  'menu_item_whatsapp_mo_routing':'Маршрутизация входящих сообщений',
  'menu_item_statistics_whatsapp_inbound_detail':'Детальная статистика входящих WhatsApp',
  'menu_item_statistics_whatsapp_inbound_group':'Групповая статистика входящих WhatsApp',
  'menu_item_mail_notify':'Mail Notify',
  'menu_item_mail_notify_templates': 'Шаблоны',
  'menu_item_mail_notify_external_templates': 'Операторские шаблоны Mail Notify',
  'menu_item_statistics_mail_notify_detail': 'Детальная статистика',
  'menu_item_statistics_mail_notify_group': 'Групповая статистика',
  'menu_item_mail_notify_external_services': 'Операторские сервисы Mail Notify',
  'menu_item_mail_notify_clients_tariff': 'Тарификация Mail Notify клиентов',
  'menu_item_mail_notify_provider_tariff': 'Тарификация Mail Notify поставщиков услуг',
  'menu_item_statistics_whatsapp_mo_detail':'Детальная статистика входящих WhatsApp',
  'menu_item_statistics_whatsapp_mo_group':'Групповая статистика входящих WhatsApp',
  'menu_item_custom': "Custom",
  'menu_item_custom_templates': "Шаблоны",
  'menu_item_statistics_custom_detail': "Детальная статистика",
  'menu_item_statistics_custom_group': "Групповая статистика",
  'menu_item_custom_clients_tariff': "Тарификация Custom клиентов",
  'menu_item_custom_provider_tariff': "Тарификация Custom поставщиков услуг",
  'menu_item_custom_mo_routing': "Маршрутизация входящих сообщений",
  'menu_item_statistics_custom_inbound_detail': "Детальная статистика входящих Custom",
  'menu_item_statistics_custom_inbound_group': "Групповая статистика входящих Custom",
  'menu_item_tools':'Инструменты',
  'menu_item_tools_message_forwarding':'Повторная отправка сообщений',
  'menu_item_sms_mo_routing':'Маршрутизация входящих сообщений',
  'menu_item_finance_balances':'Управление балансами',
  'menu_item_finance_overdrafts':'Балансы клиентов',
  'menu_item_settings_message_categories':'Категории сообщений',
  'menu_item_settings_quantity_limits':'Ограничение количества отправляемых сообщений',
  'menu_item_contacts_black_lists':'Черные списки',
  'menu_item_settings_white_list': 'Белый список',
  'menu_item_settings_proxy':'Прокси-серверы',
  'menu_item_push_applications_groups': 'Группы приложений',
  'menu_item_push_subscribers_management': 'Управление подписчиками',
  'menu_item_push_devices_management': 'Управление устройствами',
  'menu_item_statistics_cdp_events_detail': 'Детальная статистика CDP-событий',
  'menu_item_statistics_cdp_events_group': 'Групповая статистика CDP-событий',
  'menu_item_cdp_settings_cdp_client_attributes_managing': 'Управление атрибутами клиента CDP',
  'menu_item_cdp_settings_cdp_event_attributes_managing': 'Управление атрибутами события CDP',
  'menu_item_cdp_settings_cdp_client_condition_groups': 'Группы условий клиента CDP',
  'menu_item_cdp_settings_cdp_event_condition_groups': 'Группы условий события CDP',
  'menu_item_cdp_settings_cdp_scenario_managing': 'Управление сценариями CDP',
};

export default pages;
